<div *ngIf="nota"
    class="card nota-card"
    [class.editing]="isEditing">
    <div class="card-header">
        <sgt-avatar
          [settings]="{
            fullName: nota.nomeUsuarioCreated,
            imageUrl: nota.avatarUrlUsuarioCreated,
            isShowLabelNameRight: true
          }">
        </sgt-avatar>

        <div class="dropdown dropleft nota-options" *ngIf="canEdit || canDelete">
            <button type="button" class="btn btn-link dropdown-toggle dropdown-toggle-options" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1">
                <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" (click)="editClick()" *ngIf="canEdit">
                    <i class="fas fa-pencil-alt"></i> Editar
                </a>
                <a class="dropdown-item dropdown-item-delete" (click)="delete.emit(nota)" *ngIf="canDelete">
                    <i class="far fa-trash-alt" aria-hidden="true"></i> Excluir
                </a>
            </div>
        </div>
    </div>

    <ng-template [ngIf]="!isEditing">
        <div class="card-body" [innerHTML]="nota.texto | safe:'html'"></div>
        <div class="card-footer">
            <div class="nota-created-at">
                {{nota.createdAt | date: 'dd/MM/yyyy'}} às {{nota.createdAt | date: 'HH:mm'}}
            </div>
        </div>
    </ng-template>

    <ng-template [ngIf]="isEditing">
        <form #form="ngForm" novalidate>
            <sgt-rich-text-editor
              [(ngModel)]="notaEditing.texto"
              name="notaTexto_{{notaEditing.id}}"
              id="notaTexto_{{notaEditing.id}}"
              #notaTexto="ngModel"
              [control]="notaTexto.control"
              [settings]="{
                required: true,
                autofocus: true
              }">
            </sgt-rich-text-editor>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-light mr-2" (click)="cancel()">
                    <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-success" (click)="save()" [disabled]="form.invalid">
                    <i class="fas fa-check"></i> Salvar
                </button>
            </div>
        </form>
    </ng-template>

</div>
